<template>
    <v-footer
        v-bind="localAttrs"
        :padless="true">
        <v-card
            flat
            tile
            width="100%"
            class="primary lighten-1 text-center"
            >
            
            <v-card-text class="white--text footer-text" >
              <span>
            <small>{{$store.state.disclaimer}} - {{ new Date().getFullYear() }}</small>
            <strong style="position: absolute; bottom: 4px; right: 10px;">{{ date }}</strong>
            </span>
            </v-card-text>
        </v-card>


    </v-footer>
</template>

<style scoped src="@/assets/styles/Footer.css"></style>

<script>
  export default {
    name: 'Footer',

    data: () => ({
      localAttrs:{fixed : true},
      date: (new Date()).toLocaleString("es")
    }),
    mounted() {
      this.$options.timer = window.setTimeout(this.dateToString, 1000);
    },
    beforeDestroy() {
      window.clearTimeout(this.$options.timer);
    },
    methods:{
      dateToString(){
        this.date = (new Date()).toLocaleString("es")
        this.$options.timer = window.setTimeout(this.dateToString, 1000);
      }
    }
  }
</script>
